// extracted by mini-css-extract-plugin
export default {"errorBody":"ErrorMessage-module__errorBody__l4PBj"};